import { http } from "../services/http";
import type { TotpEnrolment } from "./auth";

export function adminLogin(credentials: { UserName?: string; Password?: string }): Promise<void> {
  return http.post("/admin/login", credentials);
}

export function adminLogout(): Promise<void> {
  return http.post("/admin/logout");
}

// Each call makes a new secret.
export function getAdminTotpEnrolment(options: { signal?: AbortSignal } = {}): Promise<TotpEnrolment> {
  return http.get<TotpEnrolment>("/admin/otp/generate", options);
}

// deferEnrolment postpones enrolment to the next sign-in, where the server allows it.
export function verifyAdminTotp(body: { Code: string } | { deferEnrolment: true }): Promise<void> {
  return http.post("/admin/otp/verify", body);
}

// Only the TOTP fields are set until TOTP is verified.
export function getAdminStatus(): Promise<Record<string, any> | null> {
  return http.get<Record<string, any> | null>("/admin/status");
}

// The metadata endpoint answers only when admin SAML is configured.
export async function getAdminSamlEnabled(options: { signal?: AbortSignal } = {}): Promise<boolean> {
  try {
    await http.get("/admin/saml/metadata", options);
    return true;
  } catch {
    return false;
  }
}
